export const COUNT_LIST_NEWS_SUCCESS = "COUNT_LIST_NEWS_SUCCESS";

export const LIST_NEWS_SUCCESS = "LIST_NEWS_SUCCESS";

export const GET_TOTAL_LIST_NEWS = "GET_TOTAL_LIST_NEWS";

export const GET_LIST_NEWS = "GET_LIST_NEWS";

export const LIST_NEWS_BANNERS = "LIST_NEWS_BANNERS";

export const LIST_NEWS_BANNERS_SUCCESS = "LIST_NEWS_BANNERS_SUCCESS";
